import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Container, Button, Row, Col, Spinner } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faInfo,
    faEdit,
    faTrash,
    faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
//import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';

import paginationFactory from "react-bootstrap-table2-paginator";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import swal from 'sweetalert';
import { deleteGC} from "./GastoCorrienteAction";
import { withRouter } from 'react-router-dom';


const { SearchBar } = Search;

const defaultSorted = [
    {
        dataField: "idcosto",
        order: "asc",
    },
];

const mapStateToProps = (state) => {
    //console.log("Javier -------> Se carga TableComponent|MapStateToProps ");

    return {
        getGCList: state.GastoCorrienteReducer.getGCList,
        errorGCList: state.GastoCorrienteReducer.errorGCList,
        getGCBorrar: state.GastoCorrienteReducer.getGCBorrar,
        errorGCBorrar: state.GastoCorrienteReducer.errorGCBorrar,
    };

};

function columnFormatter(cell, row) { return (<span className="font-12">{cell}</span>); }

function headFormatter(column, colIndex) { return (<strong >{column.text}</strong>); }


const GastoCorrienteTabla = (props) => {
    //console.log("Javier -------> Se carga TableComponent | PROPS");


    //Idtutor

    const columns = [
        {
            dataField: "idcosto",
            text: "ID",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "nombre",
            text: "Concepto Del Gasto",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "monto",
            text: "Monto",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "link",
            text: "",
            formatter: (rowContent, row) => {
                return (
                    <div>
                        
                        <Link to={"borrargastocorriente/" + row.idcosto}>
                            <button type="button" className="btn btn-icon btn-sm" title="Borrar Gasto Corriente"><i className="fa fa-trash-o text-danger"></i></button>
                        </Link>

                    </div>
                );
            },
        },
    ];


    var total = props.getGCList.length;

    return (

        <Container>

            {
                props.getGCList ? (
                    <ToolkitProvider
                        bootstrap4
                        keyField="idcosto"
                        data={props.getGCList}
                        columns={columns}
                        defaultSorted={defaultSorted}
                        search
                    >
                        {(props) => (
                            <div>
                                <Row>
                                    <Col>
                                        <div className="float-right">
                                            <SearchBar {...props.searchProps} placeholder="Buscar En Lista .." />
                                        </div>
                                    </Col>
                                </Row>

                                <BootstrapTable
                                    keyField="idcosto"
                                    {...props.baseProps}
                                    pagination={paginationFactory(
                                        {
                                            showTotal: true, // display pagination information
                                            sizePerPageList: [
                                                {
                                                    text: '50', value: 50
                                                },
                                                {
                                                    text: '100', value: 100
                                                },
                                                {
                                                    text: 'Todos', value: total
                                                }
                                            ],
                                            firstPageText: 'Primero', // the text of first page button
                                            prePageText: 'Previo', // the text of previous page button
                                            nextPageText: 'Siguiente', // the text of next page button
                                            lastPageText: 'Ultimo', // the text of last page button
                                            nextPageTitle: 'Ir Siguiente', // the title of next page button
                                            prePageTitle: 'Ir Previo', // the title of previous page button
                                            firstPageTitle: 'Ir Primero', // the title of first page button
                                            lastPageTitle: 'Ir Ultimo', // the title of last page button
                                        }
                                    )
                                    }
                                />
                            </div>
                        )}
                    </ToolkitProvider>
                ) :
                    (
                        <div className="text-center">
                            {props.errorGCList ? (
                                <h4>{props.errorGCList}</h4>
                            ) : (
                                    <Spinner color="dark" />
                                )}
                        </div>
                    )
            }
        </Container>

    );
};

export default withRouter(connect(mapStateToProps, null)(GastoCorrienteTabla));

